import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { useLocation, useHistory } from 'react-router-dom';
import { apiClient } from '../../../helpers/apiHelperV2';

function FAQs() {
    const standortUrl = useSelector(standortUrlSelector);
    const location = useLocation();
    const history = useHistory();

    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const response = await apiClient.get(`/api/v1/standorte/${standortUrl}/faqs`);
                // add / to the beginning of faq.url if not present
                response.data?.faqs.forEach(faq => {
                    if (!faq.url.startsWith('/')) {
                        faq.url = '/' + faq.url;
                    }
                });

                let filteredFaqs = response.data?.faqs.filter(faq => faq.url === location.pathname);
                setFaqs(filteredFaqs);
            } catch (error) {
                console.error('Error fetching FAQs:', error);
            }
        };

        fetchFaqs();
    }, [standortUrl, location.pathname]);

    useEffect(() => {
        const existingScript = document.getElementById('faq-json-ld');
        if (existingScript) existingScript.remove();
        
        if (faqs.length === 0) return;
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map(faq => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer,
                },
            })),
        };

        const script = document.createElement('script');
        script.id = 'faq-json-ld';
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify(faqStructuredData);
        document.head.appendChild(script);
    }, [faqs]);

    if (faqs.length === 0) {
        return null;
    }

    return (
        <div className="uk-section" style={{ backgroundColor: '#F1F1F1', marginTop: '40px' }}>
            <div className="uk-container">
                <h2 className="uk-h2 uk-text-bold uk-margin-medium-bottom">Häufig gestellte Fragen</h2>
                <ul className="uk-accordion" data-uk-accordion>
                    {faqs.map((faq, index) => (
                        <li key={faq.question} style={{ cursor: 'pointer', borderTop: '1px solid #7c7c7c7a' }}>
                            <button className="uk-accordion-title faq-header-button" aria-controls={`faq-content-${index}`} tabIndex={0}>
                                <h3>{faq.question}</h3>
                            </button>
                            <div className="uk-accordion-content content-for-faq" id={`faq-content-${index}`}>
                                <p className="answer">{faq.answer}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default FAQs;
